import React, { useEffect, useState } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Row, Col, Input, Form } from 'reactstrap';
import { AccountType, EmailAddress, EmailsPlaceHolder, FirstName, LastName } from '../../../utils/Constant';
import { Btn } from '../../../AbstractElements';
import { updateUserAction, updateUserByAdminAction } from '../../../Api/auth';
import { toast } from 'react-toastify';
import { useAppSelector } from '../../../ReduxToolkit/Hooks';

interface EditUserModalProps {
  modal: boolean
  setModal: (isModal: boolean) => void;
  user: any
  users: any
  setUsers: (users: any) => void;
}

const EditUserModal: React.FC<EditUserModalProps> = ({ modal, setModal, user, users, setUsers }) => {
  const [firstname, setFirstName] = useState(user?.firstname);
  const [lastname, setLastName] = useState(user?.lastname);
  const [email, setEmail] = useState(user?.email);
  const [phonenumber, setPhoneNumber] = useState(user?.phonenumber);
  const [role, setRole] = useState(user?.role);
  const userSelf = useAppSelector(state => state.user)
  const toggle = () => setModal(!modal);

  useEffect(() => {
    setFirstName(user?.firstname)
    setLastName(user?.lastname)
    setEmail(user?.email)
    setPhoneNumber(user?.phonenumber)
    setRole(user?.role)
  }, [user])

  const updateUserHandle = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const _user = {
      ...user, firstname, lastname, email, phonenumber, role,
    }
    const response = await updateUserByAdminAction(_user)
    if (response.data && response.data.status === "success") {
      toast.success("Updated User Successfully!");
      const _users = users.map((u: any) => {
        if (u.id === _user.id)
          return _user
        return u
      })
      setUsers(_users)
      toggle()
    }

    else {
      const _response: any = response
      if (_response?.response)
        toast.error(_response.response.data.message)
      else
        toast.error("Update failed!")
    }
  };

  return (
    <div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Edit User</ModalHeader>
        <Form className="theme-form" onSubmit={(event: any) => updateUserHandle(event)}>
          <ModalBody>
            <FormGroup>
              <Label className="col-form-label pt-0">{"User Name"}</Label>
              <Row className="g-2">
                <Col xs="6">
                  <Input type="text" required value={firstname} placeholder={FirstName} onChange={(event) => setFirstName(event.target.value)} />
                </Col>
                <Col xs="6">
                  <Input type="text" required value={lastname} placeholder={LastName} onChange={(event) => setLastName(event.target.value)} />
                </Col>
              </Row>
            </FormGroup>
            <FormGroup>
              <Label className="col-form-label">{EmailAddress}</Label>
              <Input type="email" required placeholder={EmailsPlaceHolder} value={email} onChange={(event) => setEmail(event.target.value)} />
            </FormGroup>
          </ModalBody>
          <ModalFooter>
            <Button color="primary">
              Save
            </Button>{' '}
            <Button color="danger" onClick={() => {
              setFirstName(user.firstname)
              setLastName(user.lastname)
              setEmail(user.email)
              setPhoneNumber(user.phonenumber)
              toggle()
            }}>
              Cancel
            </Button>
          </ModalFooter>
        </Form>

      </Modal>
    </div>
  );
}

export default EditUserModal;